// import tcrud_mix from '@/components/DataTables/tcrud_mix'
// mixins: [tcrud_mix]
import { toggleArr } from '@/helpers/helpers'
import TableDeleteBtns from '@/components/DataTables/TableDeleteBtns'
import TableMainCheckbox from '@/components/DataTables/TableMainCheckbox'

const tcrud_mix = {
  data() {
    return {
      l_tcrud_params: '',
      tcrud_customLoading: false,
      tcrud_draggedItem: null,
      tcrud_lastTouchedIdx: -1,
      tcrud_limit: 100,
      tcrud_offset: 0,
      tcrud_selectedItems: [],
    }
  },
  watch: {
    tcrud_params: {
      immediate: false,
      handler: 'tcrud_getDataCheck',
    },
  },
  emits: ['trcud:deleteFinished'],
  methods: {
    tcrud_updatePagination({ offset, limit }) {
      this.tcrud_offset = offset
      this.tcrud_limit = limit
      this.tcrud_getDataCheck()
    },
    tcrud_getDataCheck(options) {
      const strParams = JSON.stringify(this.tcrud_params)
      if (this.l_tcrud_params === strParams) return

      // weird bug reported by a user
      if (this.$store.getters.panel_replay && this.tcrud_endpoint !== 'poker/files/') {
        console.error('TABLE-updated-under-replay', this.tcrud_endpoint, strParams)
      }

      this.l_tcrud_params = strParams
      this.tcrud_getData(options)
    },
    tcrud_getData({ mergeData } = {}) {
      this.tcrud_selectedItems = []
      this.tcrud_lastTouchedIdx = -1

      const callId = `tcrud_getData_${this.tcrud_endpoint}`
      this.$store.dispatch('api_call', {
        apiVersion: this.tcrud_apiVersion,
        endpoint: this.tcrud_endpoint,
        mutation: this.tcrud_mutation,
        hasCancel: true,
        callId,
        params: this.tcrud_params,
        mergeData,
      })
    },
    tcrud_toggleSelected(item, index, items) {
      const idKey = this.tcrud_conf.idKey || 'id'
      const res = !this.tcrud_selectedItems.some(i => i?.[idKey] === item[idKey])
      const shiftKeyPressed = this.$store.getters.hotkey_pressed_bottom === 'shift'

      this.tcrud_selectedItems[index] = res ? item : null
      const lstIdx = this.tcrud_lastTouchedIdx
      if (shiftKeyPressed && lstIdx !== index && items[lstIdx]) {
        if (lstIdx < index) {
          this.tcrud_selectedItems = items.map((i, idx) =>
            idx >= lstIdx && idx <= index ? (res ? i : null) : this.tcrud_selectedItems[idx],
          )
        } else {
          this.tcrud_selectedItems = items.map((i, idx) =>
            idx <= lstIdx && idx >= index ? (res ? i : null) : this.tcrud_selectedItems[idx],
          )
        }
      }
      this.tcrud_selectedItems = this.tcrud_selectedItems.map(i => i)

      if (this.tcrud_selectedItems.every(i => !i)) {
        this.tcrud_lastTouchedIdx = -1
      } else {
        this.tcrud_lastTouchedIdx = index
      }
    },
    tcrud_toggleSelectedAll() {
      this.tcrud_lastTouchedIdx = -1
      this.tcrud_selectedItems =
        this.tcrud_mainCheckboxValue === 'all'
          ? this.tcrud_items.map(i => null)
          : this.tcrud_items.map(i => i)
    },
    tcrud_deleteItem(item) {
      this.tcrud_singleDeleteSelectedItems([item])
    },
    tcrud_singleDeleteSelectedItems(selectedItems = this.tcrud_selectedItems) {
      if (this.tcrud_customLoading) return

      const items = selectedItems.filter(i => i)

      const requests = items.map(item => {
        const endpoint = this.tcrud_conf.getDeleteEndpoint(item)
        return this.$store.dispatch('api_call', {
          method: 'DELETE',
          apiVersion: this.tcrud_conf.apiVersion || '',
          endpoint,
        })
      })

      this.tcrud_customLoading = true
      const { length } = requests
      Promise.all(requests).then(values => {
        if (values.every(res => res?.response?.status === 204)) {
          this.$store.dispatch('messages', {
            type: 'success',
            text: this.$tc(this.tcrud_conf.deleteSuccessMessage, length),
            hide: true,
          })
        } else {
          this.$store.dispatch('messages', {
            type: 'error',
            status: 'error_deleting_rows',
            statusMessages: {
              _error_deleting_rows: {
                i18n: this.tcrud_conf.deleteErrorMessage,
              },
            },
          })
        }
        this.tcrud_getData()
        this.tcrud_customLoading = false

        this.$emit('trcud:deleteFinished')
      })
    },
    async tcrud_batchDeleteSelectedItems() {
      if (this.tcrud_customLoading) return

      const idKey = this.tcrud_conf.idKey || 'id'
      const ids = this.tcrud_selectedItems.map((i, idx) => i?.[idKey] || null).filter(i => i)

      const endpoint = this.tcrud_conf.getBatchDeleteEndpoint()
      const res = await this.$store.dispatch('api_call', {
        method: 'POST',
        apiVersion: this.tcrud_conf.apiVersion || '',
        endpoint,
        data: {
          entities: ids,
        },
      })
      if (res?.response?.status === 204) {
        this.$store.dispatch('messages', {
          type: 'success',
          text: this.$tc(this.tcrud_conf.deleteSuccessMessage, ids.length),
          hide: true,
        })
      } else {
        this.$store.dispatch('messages', {
          type: 'error',
          status: 'error_deleting_rows',
          statusMessages: {
            _error_deleting_rows: {
              i18n: this.tcrud_conf.deleteErrorMessage,
            },
          },
        })
      }
      this.tcrud_getData()

      this.$emit('trcud:deleteFinished')
    },
    tcrud_patchItem({ item, patchData, expected_item }, method = 'PATCH') {
      const endpoint = this.tcrud_conf.getEndpoint(item)

      this.$store.dispatch('api_call', {
        apiVersion: this.tcrud_conf.apiVersion || '',
        method,
        hasCancel: false,
        endpoint,
        data: patchData,
        message: {
          type: 'error',
        },
      })

      if (!expected_item) return

      const idKey = this.tcrud_conf.idKey || 'id'
      const apiData = this.$store.getters.api_get_data(this.tcrud_mutation)
      if (!apiData) return

      const results = (apiData.results || apiData.items || apiData || []).map(i => {
        if (i[idKey] === expected_item[idKey]) {
          return {
            ...expected_item,
          }
        }
        return i
      })

      const data = apiData.items
        ? { ...apiData, items: results }
        : !apiData.results
          ? results
          : { ...apiData, results }

      this.$store.commit('api_update_data', {
        key: this.tcrud_mutation,
        data,
      })

      this.tcrud_updateDetached(data)
    },
    tcrud_updateDetached(data) {
      const channelId = this.tcrud_conf?.getChannelId ? this.tcrud_conf?.getChannelId() : null
      if (channelId) {
        this.$store.dispatch('bc_postMessage', {
          channelId,
          data: {
            code: 'api_update',
            value: JSON.parse(
              JSON.stringify({
                data,
                key: this.tcrud_mutation,
              }),
            ),
          },
        })
      }
    },

    async tcrud_queuePatchItems({ items }) {
      this.tcrud_customLoading = true
      const firstItem = items.shift()

      await this.tcrud_asyncPatchItem({
        item: firstItem.item,
        patchData: firstItem.patchData,
      })

      if (items.length) {
        this.tcrud_queuePatchItems({ items })
      } else {
        this.tcrud_customLoading = false
      }
    },
    async tcrud_asyncPatchItem({ item, patchData }) {
      const endpoint = this.tcrud_conf.getEndpoint(item)
      const result = await this.$store.dispatch('api_call', {
        apiVersion: this.tcrud_conf.apiVersion || '',
        method: 'PATCH',
        hasCancel: false,
        endpoint,
        data: patchData,
        message: {
          type: 'error',
        },
      })
      return result
    },

    tcrud_handleTagClick({ tag, item }) {
      let tags = item.tags.map(tt => tt.id)
      tags = toggleArr({ arr: tags, item: tag.id })
      const expected_item = {
        ...item,
        tags: this.allTags.filter(tt => tags.includes(tt.id)),
      }
      this.tcrud_patchItem({
        item,
        patchData: { tags },
        expected_item,
      })
    },
    tcrud_scrollTable(e) {
      if (!this.$refs.tablebody) return
      const { top, bottom } = this.$refs.tablebody.$el.getBoundingClientRect()
      let { clientY } = e
      if (e?.touches) {
        clientY = e?.touches[0]?.clientY
      }
      if (clientY < top + 32) {
        this.$refs.tablebody.scrollBy(-32)
      } else if (clientY > bottom - 32) {
        this.$refs.tablebody.scrollBy(32)
      }
    },
    tcrud_getDragIndicatorStyle(style) {
      // remember to set dropTargetIdPart on DragDropHandler
      if (!this.$refs.tablebody) return style
      const { width } = this.$refs.tablebody.$el.getBoundingClientRect()
      const res = {
        ...style,
        width: `${width}px`,
      }
      return res
    },
    tcrud_handleDragstart({ e, item }) {
      this.tcrud_draggedItem = item
      if (this.$refs.dragdrophandler) {
        this.$refs.dragdrophandler.startDrag(e)
      }
    },
    tcrud_handleDragdrop({ e, dropTarget, dropSurface, dropTargetIdPart }) {
      if (dropTarget && dropSurface) {
        const dropIdx = Number(dropTarget.id.replace(`${dropTargetIdPart}_`, ''))
        const dropItem = this.tcrud_items[dropIdx]

        const items = this.tcrud_itemsDrag

        const draggedRows = this.tcrud_draggedItems
        const idKey = this.tcrud_conf.idKey || 'id'
        if (draggedRows.some(i => i.id === dropItem[idKey])) return

        const first = draggedRows[0]
        const dropItemIdx = items.findIndex(i => i[idKey] === dropItem[idKey])
        const draggedItemIdx = items.findIndex(i => i[idKey] === first[idKey])

        const afterVal = dropItemIdx < draggedItemIdx ? 1 : 0
        const beforeVal = dropItemIdx < draggedItemIdx ? 0 : -1

        const l = items.length
        const increment = dropSurface === 'after' ? afterVal : beforeVal
        let op = dropItemIdx + increment
        op = op < 0 ? 0 : op > l ? l : op

        let expected_items = items.filter(i => !draggedRows.find(ii => ii[idKey] === i[idKey]))
        expected_items.splice(op, 0, draggedRows)
        expected_items = expected_items.flat()

        const { sortOrder } = this.tbl_sortConf
        if (sortOrder === 'desc') {
          op = l - op
          expected_items = expected_items.map((i, idx) => ({
            ...i,
            ordering_position: l - idx,
          }))
        } else {
          op += 1
          expected_items = expected_items.map((i, idx) => ({
            ...i,
            ordering_position: idx + 1,
          }))
        }

        let patchItems = draggedRows.map((item, idx) => ({
          item,
          patchData: {
            ordering_position: op,
          },
        }))

        // reorder so it mimics as if you've done it manually
        // if you drag a row to the top, it has to flip
        if (sortOrder === 'desc' || op < draggedRows[0]?.ordering_position) {
          patchItems = patchItems.sort((a, b) =>
            a.item.ordering_position < b.item.ordering_position ? 1 : -1,
          )
        } else {
          patchItems = patchItems.sort((a, b) =>
            a.item.ordering_position < b.item.ordering_position ? -1 : 1,
          )
        }
        this.tcrud_queuePatchItems({ items: patchItems })

        const apiData = this.$store.getters.api_get_data(this.tcrud_mutation)
        const results = expected_items

        const data = !apiData.results ? results : { ...apiData, results }
        this.$store.commit('api_update_data', {
          key: this.tcrud_mutation,
          data,
        })
      }
      this.tcrud_draggedItem = null
      this.tcrud_selectedItems = []
    },
    tcrud_resetSelectedRows() {
      this.tcrud_selectedItems = []
    },
  },
  computed: {
    tcrud_trulySelectedItems() {
      return this.tcrud_selectedItems.filter(i => i)
    },
    tcrud_mainCheckboxValue() {
      const { length } = this.tcrud_selectedItems
      const selectedLength = this.tcrud_trulySelectedItems.length
      if (!selectedLength) {
        return 'none'
      }
      if (selectedLength === length) {
        return 'all'
      }
      return 'indeterminate'
    },
    tcrud_draggedItems() {
      const idKey = this.tcrud_conf.idKey || 'id'

      const res = this.tcrud_draggedItem
        ? this.tcrud_selectedItems.some(i => this.tcrud_draggedItem[idKey] === i?.[idKey])
          ? this.tcrud_selectedItems.filter(i => i)
          : [this.tcrud_draggedItem]
        : []

      return res
    },
  },
  components: {
    TableDeleteBtns,
    TableMainCheckbox,
  },
}

export default tcrud_mix
